// src/i18n.js (or wherever your i18n file lives)
import { createI18n } from "vue-i18n";

const messages = {
  en: {
    // Home Page Translations
    welcome: "WELCOME TO",
    foods: "Foods",
    reserv: "BOOK NOW",
    soon: "COMING SOON",
    followInsta: "FOLLOW US ON INSTAGRAM",
    testimonials: "TESTIMONIALS",
    loadingTestimonials: "Loading testimonials...",
    quote:
      "Always Hungry is not just a caterer, we are a culinary brand aiming to redefine the way people experience food, culture, and celebration. – Always Hungry Foods",

    cateringTitle: "Catering",
    venueTitle: "Venue",
    serviceFallback: "Service",

    // Catering Page Translations
    cateringBannerTitle: "Why Choose Our Catering?",
    cateringBannerText:
      "We deliver unforgettable culinary experiences for every event.",
    
    ourServices: "OUR SERVICES",
    pdfTitle: "Catering Menu",
    pdfText: "View our full menu and packages.",
    openPdf: "Open PDF",
    firstName: "First Name",
    firstNamePlaceholder: "Enter your first name",
    lastName: "Last Name",
    lastNamePlaceholder: "Enter your last name",
    email: "Email",
    emailPlaceholder: "Enter your email",
    serviceType: "Service Type",
    select: "Select an option",
    wedding: "Wedding",
    corporate: "Corporate",
    private: "Private Event",
    guests: "Number of Guests",
    guestsPlaceholder: "Enter number of guests",
    description: "Description",
    descriptionPlaceholder: "Describe your event here...",
    submit: "SUBMIT",

    // About Us Page Translations
    ourStoryAlt: "Our Story Image",
    ourChefAlt: "Our Chef Image",
    ourStoryTitle: "OUR STORY",
    ourStoryHeading: "Discover our culinary story",
    ourStoryDescription:
      "Founded in Montréal, Always Hungry Inc. began as a small kitchen with a big ambition: to create more than just food, but experiences that celebrate culture and connection. From our Hungry’s fusion fast-casual concept to Always Hungry Catering, we blend global inspiration with local craftsmanship to deliver chef-driven, design-minded dining. What sets us apart is our fusion of authenticity, quality, and innovation and where luxury feels approachable and every event becomes a tailored experience. As we grow through new ventures and collaborations, our vision remains the same: to redefine how people experience food, culture, and celebration.",
    traditionAuthenticity: "Tradition and authenticity",
    carefullyChosenIngredients: "Carefully chosen ingredients",
    familyPassion: "Family passion",
    loading: "Loading...",

    // Contact Page Translations
    contactTitle: "Contact Us",
    contactHeading: "Ready to collaborate?",
    yourName: "Your Name",
    yourEmail: "Email",
    subject: "Subject",
    typeMessage: "Type here...",
    contactDescription:
      "We are here to answer your questions, requests, or projects. Feel free to write to us and we will reply as soon as possible.",
    phoneNumber: "Phone Number",
        phone: "t(514) 237-0306",
        phone2: "c(514) 754-3334",
    emailLabel: "Email",
    // ✅ escape @ so vue-i18n doesn't parse it
    emailAddress: "info{'@'}alwayshungryfoods.com",
    locationLabel: "Location",
    address: "7965 Bd Décarie, Montréal, QC H4P 2H5",

    nav: {
      home: "HOME",
      brands: "OUR BRANDS",
      catering: "CATERING",
      venue: "VENUE",
      about: "ABOUT US",
      contact: "CONTACT",
    },

    brands: {
      hungrys: "HUNGRY’S",
      whealthy: "WHEALTHY",
      samosahouse: "SAMOSA HOUSE",
      chikoschicken: "CHIKO’S CHICKEN",
    },

    venue: {
      heroTitle: "VENUE",
      comingSoon: "COMING SOON",
      description: "Our venue is currently under renovation, but we are still available for catering and events. Contact us for more information.",
      newsletterTitle: "Subscribe to our newsletter",
      newsletterPlaceholder: "Your email",
      newsletterButton: "Subscribe",
    },

    footer: {
      locationTitle: "LOCATION",
      locationName: "Hungry’s",
      address: "7965 Bd Décarie, Montréal, QC H4P 2H5",
      infoTitle: "INFO & RESERVATIONS",
      phone: "t(514) 237-0306",
      phone2: "c(514) 754-3334",
      // ✅ escape @ here too
      email: "info{'@'}alwayshungryfoods.com",
      closedTitle: "CLOSED FOR RENOVATIONS",
      closedText: "We are currently undergoing renovations,Stay tuned!",
      followTitle: "FOLLOW US",
      facebook: "facebook",
      instagram: "instagram",
      copyright: "2025© ALWAYS HUNGRY — made by",
      scrollTop: "Scroll to top",
    },
  },

  fr: {
    // Home Page Translations
    welcome: "BIENVENUE À",
    foods: "Foods",
    reserv: "RÉSERVEZ MAINTENANT",
    soon: "BIENTÔT DISPONIBLE",
    followInsta: "SUIVEZ NOUS SUR INSTAGRAM",
    testimonials: "TÉMOIGNAGES",
    loadingTestimonials: "Chargement des témoignages...",
    quote:
      "Always Hungry n’est pas seulement un traiteur, nous sommes une marque culinaire avec la vision de redéfinir la manière dont les gens vivent la gastronomie, la culture et la célébration. – Always Hungry Foods",

    cateringTitle: "Service Traiteur",
    venueTitle: "Salle de Réception",
    serviceFallback: "Service",

    // Catering Page Translations
    cateringBannerTitle: "Pourquoi choisir notre service traiteur ?",
    cateringBannerText:
      "Nous offrons des expériences culinaires inoubliables pour chaque événement.",
    
    ourServices: "NOS SERVICES",
    pdfTitle: "Menu Traiteur",
    pdfText: "Consultez notre menu complet et nos forfaits.",
    openPdf: "Ouvrir le PDF",
    firstName: "Prénom",
    firstNamePlaceholder: "Entrez votre prénom",
    lastName: "Nom de famille",
    lastNamePlaceholder: "Entrez votre nom de famille",
    email: "Courriel",
    emailPlaceholder: "Entrez votre courriel",
    serviceType: "Type de service",
    select: "Choisir une option",
    wedding: "Mariage",
    corporate: "Corporatif",
    private: "Événement privé",
    guests: "Nombre d'invités",
    guestsPlaceholder: "Entrez le nombre d'invités",
    description: "Description",
    descriptionPlaceholder: "Décrivez votre événement ici...",
    submit: "SOUMETTRE",

    // About Us Page Translations
    ourStoryAlt: "Notre histoire",
    ourChefAlt: "Notre chef",
    ourStoryTitle: "Notre Histoire",
    ourStoryHeading: "Découvrez notre histoire culinaire",
    ourStoryDescription:
      "Fondée à Montréal, Always Hungry Inc. a commencé comme une petite cuisine animée d’une grande ambition : créer plus que des plats, offrir des expériences qui célèbrent la culture et la convivialité. De notre concept Hungry’s, fusion rapide et gourmande, à Always Hungry Traiteur, nous marions inspiration internationale et savoir-faire local pour proposer une cuisine créative et raffinée. Ce qui nous distingue : une fusion d’authenticité, de qualité et d’innovation, où le luxe reste accessible et chaque événement devient une expérience sur mesure. En évoluant vers de nouveaux projets et collaborations, notre vision demeure la même : redéfinir la manière dont les gens vivent la nourriture, la culture et la célébration.",
    traditionAuthenticity: "Tradition et authenticité",
    carefullyChosenIngredients: "Ingrédients soigneusement choisis",
    familyPassion: "Passion familiale",
    loading: "Chargement…",

    // Contact Page Translations
    contactTitle: "Contactez-nous",
    contactHeading: "Prêt(e) à collaborer ?",
    yourName: "Votre Nom",
    yourEmail: "Courriel",
    subject: "Sujet",
    typeMessage: "Tapez ici...",
    submit: "Soumettre",
    contactDescription:
      "Nous sommes là pour répondre à toutes vos questions, demandes ou projets. N’hésitez pas à nous écrire, nous vous répondrons dans les plus brefs délais.",
    phoneNumber: "Numéro de Téléphone",
        phone: "t(514) 237-0306",
        phone2: "c(514) 754-3334",
    emailLabel: "Courriel",
    // ✅ escape @
    emailAddress: "info{'@'}alwayshungryfoods.com",
    locationLabel: "L’emplacement",
    address: "7965 Bd Décarie, Montréal, QC H4P 2H5",

    nav: {
      home: "ACCEUIL",
      brands: "NOS MARQUES",
      catering: "SERVICE TRAITEUR",
      venue: "SALLE DE RÉCEPTION",
      about: "QUI SOMMES-NOUS",
      contact: "CONTACTEZ-NOUS",
    },

    brands: {
      hungrys: "HUNGRY’S",
      whealthy: "WHEALTHY",
      samosahouse: "SAMOSA HOUSE",
      chikoschicken: "CHIKO’S CHICKEN",
    },

    venue: {
      heroTitle: "VENUE",
      comingSoon: "BIENTÔT DISPONIBLE",
      description: "Notre salle de réception est actuellement en rénovation, mais nous sommes toujours disponibles pour le service traiteur et les événements. Contactez-nous pour plus d'informations.",
      newsletterTitle: "Abonnez-vous à notre infolettre",
      newsletterPlaceholder: "Votre courriel",
      newsletterButton: "S’inscrire",
    },

    footer: {
      locationTitle: "L’EMPLACEMENT",
      locationName: "Hungry’s",
      address: "7965 Bd Décarie, Montréal, QC H4P 2H5",
      infoTitle: "INFO & RÉSERVATIONS",
      phone: "t(514) 237-0306",
        phone2: "c(514) 754-3334",
      // ✅ escape @
      email: "info{'@'}alwayshungryfoods.com",
      closedTitle: "FERMÉ POUR TRAVAUX",
      closedText: "Always Hungry est actuellement fermé pour des rénovations,Restez branchés!",
      followTitle: "SUIVEZ-NOUS",
      facebook: "facebook",
      instagram: "instagram",
      copyright: "2025© ALWAYS HUNGRY — réalisé par",
      scrollTop: "Remonter en haut",
    },
  },
};

export default createI18n({
  legacy: false,
  locale: "fr",
  fallbackLocale: "en",
  messages,
  // optional but often convenient:
  // globalInjection: true,
});
